import { PageLayoutBackground } from './background';
import { PageLayoutHeader } from './header';
import { PageLayoutRoot } from './root';

export const PageLayout = {
  Root: PageLayoutRoot,
  Background: PageLayoutBackground,
  Header: PageLayoutHeader,
};
